const MIN_VISIBLE_MS = 300;

/**
 * Full-page loader that hides once the DOM is ready and it has been visible for a minimum time.
 */
export default function pageLoader() {
    return {
        show: true,

        init() {
            const minimumDelay = new Promise((resolve) => setTimeout(resolve, MIN_VISIBLE_MS));
            const domReady = new Promise((resolve) => {
                if (document.readyState !== 'loading') {
                    resolve();

                    return;
                }

                document.addEventListener('DOMContentLoaded', resolve, { once: true });
            });

            Promise.all([minimumDelay, domReady]).then(() => {
                this.show = false;
            });
        },
    };
}
